<template>
    <Card>
        <div style="display: flex;align-items: center;justify-content: space-between; width: 450px;">
            <RadioGroup v-model="client_type" @on-change="getList">
                <Radio label="1"><span>个人</span></Radio>
                <Radio label="2"><span>部门</span></Radio>
            </RadioGroup>
            <div>
                <span>时间周期：</span>
                <Select v-model="timePeriod" style="width:200px" @on-change="timePeriodClick">
                    <Option v-for="item in timePeriodList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
        </div>
        <div style="text-align: center; font-size: 20px;font-weight: bold;">公海客户报表</div>
        <div id="Mimelist2"></div>
        <div style="margin-top: 20px;">
            <Table size="small" :columns="columns" :data="data"></Table>
        </div>
    </Card>
</template>

<script>
    import {mapGetters} from "vuex";
	import {getSeaNums} from "../../api/statics";

	export default {
        name: "PublicClientAnalyse",
        data() {
            return {
                data: [
                ],
                columns: [{
                    title: '姓名',
                    key: 'name'
                },
                    {
                        title: '进入公共池客户数',
                        key: 'in_pool_nums'
                    },
                    {
                        title: '公共池客户领取数',
                        key: 'get_pool_nums'
                    },
                    {
                        title: '进入公海客户数',
                        key: 'in_sea_nums'
                    },

                    {
                        title: '公海客户领取数',
                        key: 'get_sea_nums'
                    }
                ],
                weekDayList: [],
                yearMonthList: [],
                client_type: '1',
                timePeriod: '0',
                timePeriodList: [{
                    value: '0',
                    label: '最近7天'
                },
                    {
                        value: '1',
                        label: '最近15天'
                    },
                    {
                        value: '2',
                        label: '最近30天'
                    },
                    {
                        value: '3',
                        label: '最近1年'
                    },
                    {
                        value: '4',
                        label: '最近2年'
                    },
                ],
                optionMy: {
                    dataZoom: [{
                        type: 'slider',
                        show: false, //flase直接隐藏图形
                        xAxisIndex: [0],
                        left: '9%', //滚动条靠左侧的百分比
                        bottom: -5,
                        start: 0, //滚动条的起始位置
                        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    }],

                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: ['进入公共池客户数', '公共池领出客户数', '进入公海客户数', '公海领出客户数'],
                        top: ''
                    },
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    },
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {
                                show: false
                            },
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [{
                        name: '进入公共池客户数',
                        type: 'bar',
                        data: [10, 20, 30, 40, 50, 60, 70],
                        color: '#4376C2',
                    },
                        {
                            name: '公共池领出客户数',
                            type: 'bar',
                            data: [10, 20, 30, 10, 50, 60, 70],
                            color: '#ED7D31'
                        },
                        {
                            name: '进入公海客户数',
                            type: 'bar',
                            yAxisIndex: 1,
                            data: [10, 20, 30, 40, 5, 60, 70],
                            color: '#A5A5A5'
                        },
                        {
                            name: '公海领出客户数',
                            type: 'bar',
                            yAxisIndex: 1,
                            data: [10, 20, 30, 40, 5, 60, 70],
                            color: '#FCBF06'
                        }
                    ],
                },


            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
        mounted() {
            this.timestampToTime(7)
            this.optionMy.xAxis[0].data = this.weekDayList;
            this.getList();
        },
        methods: {
			async getList() {
				let that = this;
				let data = {timePeriod: this.timePeriod, yearMonthList: this.yearMonthList, type: that.client_type, weekDayList: this.weekDayList}
				data.token = this.token;
				let res = await getSeaNums(that, data);
				that.optionMy.series[0].data = res.data.clientNums[0];
				that.optionMy.series[1].data = res.data.clientNums[1];
				that.optionMy.series[2].data = res.data.clientNums[2];
				that.optionMy.series[3].data = res.data.clientNums[3];
				let myChartOne = this.$echarts.init(document.getElementById("Mimelist2"));
				myChartOne.clear()
				myChartOne.setOption(this.optionMy);
				that.data = res.data.list;
			},
            timePeriodClick(e) {
                if (e == '0') {
                    this.timestampToTime(7)
                    this.optionMy.xAxis[0].data = this.weekDayList
                    this.optionMy.dataZoom[0].show = false,
                    this.optionMy.dataZoom[0].end = 100;
                } else if (e == '1') {
                    this.timestampToTime(15)
                    this.optionMy.xAxis[0].data = this.weekDayList
                    this.optionMy.dataZoom[0].show = true,
                    this.optionMy.dataZoom[0].end = 70;
                } else if (e == '2') {
                    this.timestampToTime(30)
                    this.optionMy.xAxis[0].data = this.weekDayList
                    this.optionMy.dataZoom[0].show = true,
                    this.optionMy.dataZoom[0].end = 30;
                } else if (e == '3') {
                    this.timestampToMonth(12)
                    this.optionMy.xAxis[0].data = this.yearMonthList
                    this.optionMy.dataZoom[0].show = false,
                    this.optionMy.dataZoom[0].end = 100;
                } else if (e == '4') {
                    this.timestampToMonth(24)
                    this.optionMy.xAxis[0].data = this.yearMonthList
                    this.optionMy.dataZoom[0].show = true,
                    this.optionMy.dataZoom[0].end = 50;
                }
                this.getList();
            },
            timestampToTime(type) {
                // type =0 为当天 type = 1 为前一天
                // hhmmss 自己传需要的时分秒
                let now = new Date();
                let date
                if (type === 0) {
                    date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
                } else {
                    this.weekDayList = []
                    for (let i = 0; i < type; i++) {
                        let now = new Date();
                        date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
                        var time2 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate()+1);
                        this.weekDayList.unshift(time2)
                    }
                }
            },
            timestampToMonth(type) {

                let now = new Date();
                let year = now.getFullYear()
                this.yearMonthList = []
                if (type == 12) {
                    for (let i = 0; i < type; i++) {
                        let data
                        if (i + 1 < 10) {
                            data = year + '-0' + (i + 1)
                        } else {
                            data = year + '-' + (i + 1)
                        }

                        this.yearMonthList.push(data)
                    }
                } else if (type == 24) {
                    for (let i = 0; i < 12; i++) {
                        let data
                        if (i + 1 < 10) {
                            data = year + '-0' + (i + 1)
                        } else {
                            data = year + '-' + (i + 1)
                        }

                        this.yearMonthList.push(data)
                    }
                    for (let i = 12; i > 0; i--) {
                        let data
                        if (i < 10) {
                            data = (year - 1) + '-0' + (i)
                        } else {
                            data = (year - 1) + '-' + (i)
                        }

                        this.yearMonthList.unshift(data)
                    }

                }

            },
        }
    }
</script>

<style scoped lang="less">
    #Mimelist2 {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
        padding-top: 30px;
    }
</style>
